__turbopack_context__.v({
  "CloseIcon": "Modal-module-scss-module__GBQoIG__CloseIcon",
  "InlinePanel": "Modal-module-scss-module__GBQoIG__InlinePanel",
  "Modal": "Modal-module-scss-module__GBQoIG__Modal",
  "ModalHeader": "Modal-module-scss-module__GBQoIG__ModalHeader",
  "Overlay": "Modal-module-scss-module__GBQoIG__Overlay",
});
